import { Component, OnInit } from '@angular/core';
import { StatLocation } from '../../../common/models/statistics/stat-data';
import { PageTitleService } from '../../../services/page-title.service';
import { LoggerService } from '../../../services/logger.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'psc-business-dashboard',
  templateUrl: './business-dashboard.component.html'
})
export class BusinessDashboardComponent implements OnInit {
  statData: StatLocation[];
  loading: boolean;
  selectedLocation: google.maps.LatLngLiteral;

  constructor(
    private pageTitleService: PageTitleService,
    private loggerService: LoggerService,
  ) {
    {
      /**
       * t(title.customer.business-dashboard)
       */
      this.pageTitleService.setTitle('title.customer.business-dashboard');
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.loggerService.getBusinessStatistics()
      .pipe(finalize(() => this.loading = false))
      .subscribe((response) => {
        this.statData = response;
      });
  }

  locationClicked(event: { lat: string; lng: string }) {
    this.selectedLocation = { lat: +event.lat, lng: +event.lng };
  }
}
